import React from "react";

export default function Logo({ className = "", height = 26 }) {
  return (
    <div
      role="img"
      aria-label="Materassi & Materassi"
      data-testid="materassi-logo"
      style={{
        height,
        lineHeight: `${height}px`,
        fontSize: Math.max(18, Math.round(height * 0.92)),
        fontFamily: '"Cormorant Garamond", Georgia, serif',
        textShadow: "0 1px 2px rgba(0,0,0,0.35)",
      }}
      className={`select-none whitespace-nowrap text-white font-semibold italic ${className}`}
    >
      <span>Materassi</span>
      <span className="inline-block px-1 text-[1.15em]">&amp;</span>
      <span>Materassi</span>
    </div>
  );
}
